// import { gatewayClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import { IMeta, IModifier, IModifierCategoryUpsertArgs } from 'src/common/interfaces/index.js'

const IModifierListResponse = { meta: IMeta, data: { list: [IModifier] } }

export const inventoryModifierCategory = {
  /**
   * @param {id: number} filter
   * @return {IModifierListResponse}
   */
  list(filter, signal) {
    return businessClient().post('inventory/modifier/category/portal/list', { filter }, { signal })
  },

  /**
   * @param {IModifierCategoryUpsertArgs} data
   * @return {IInsertResponse}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/modifier/category/upsert', { data }, { signal })
  },
}
